import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X } from "lucide-react";
import { useLang } from "../context/LanguageContext";

export default function WhatsAppFloat() {
  const { lang } = useLang();
  const [showTooltip, setShowTooltip] = useState(true);
  const phone = "+237694056334";
  const msg = encodeURIComponent(
    lang === "fr"
      ? "Bonjour Josias, j'ai vu votre site JNIC et je souhaite discuter de mon projet d'immigration canadienne / préparation TCF."
      : "Hello Josias, I saw your JNIC website and would like to discuss my Canadian immigration / TCF preparation project."
  );

  return (
    <div className="fixed bottom-6 right-6 z-40 flex items-center gap-3">
      <AnimatePresence>
        {showTooltip && (
          <motion.div
            initial={{ opacity: 0, x: 10, scale: 0.95 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            className="hidden sm:flex items-center gap-2 bg-[#06162A] text-white text-xs py-2 px-3.5 rounded-full shadow-xl border border-white/10"
          >
            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
            <span>
              {lang === "fr" ? "Discuter sur WhatsApp avec Josias" : "Chat on WhatsApp with Josias"}
            </span>
            <button
              onClick={(e) => {
                e.stopPropagation();
                setShowTooltip(false);
              }}
              className="text-white/40 hover:text-white ml-1"
              aria-label="Fermer"
            >
              <X size={12} />
            </button>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.a
        href={`https://wa.me/${phone.replace(/[^0-9]/g, "")}?text=${msg}`}
        target="_blank"
        rel="noreferrer"
        data-testid="whatsapp-float"
        initial={{ scale: 0, rotate: -90 }}
        animate={{ scale: 1, rotate: 0 }}
        transition={{ delay: 0.8, type: "spring", stiffness: 200 }}
        whileHover={{ scale: 1.08 }}
        className="relative w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg shadow-emerald-900/30 hover:bg-[#1FB855] transition-colors"
        aria-label="WhatsApp Support"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" />
        <MessageCircle size={26} strokeWidth={2.2} />
      </motion.a>
    </div>
  );
}
